import { render, staticRenderFns } from "./selectMemberModal.vue?vue&type=template&id=12a27b84&"
import script from "./selectMemberModal.vue?vue&type=script&lang=ts&"
export * from "./selectMemberModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports